"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageWorldState = exports.sendMessageAndImmediatelyExecute = exports.sendDestroyMessageAndImmediatelyExecute = exports.sendCreateMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EVoyageCrewCarryCommand = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_1 = require("@main/common");
var voyageCarryable_sidecar_1 = require("@voyage/entities/voyageCarryable-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var EVoyageCrewCarryCommand;
(function (EVoyageCrewCarryCommand) {
    EVoyageCrewCarryCommand[EVoyageCrewCarryCommand["Create"] = 0] = "Create";
    EVoyageCrewCarryCommand[EVoyageCrewCarryCommand["Destroy"] = 1] = "Destroy";
    EVoyageCrewCarryCommand[EVoyageCrewCarryCommand["Pickup"] = 2] = "Pickup";
    EVoyageCrewCarryCommand[EVoyageCrewCarryCommand["Drop"] = 3] = "Drop";
    EVoyageCrewCarryCommand[EVoyageCrewCarryCommand["Swap"] = 4] = "Swap";
})(EVoyageCrewCarryCommand = exports.EVoyageCrewCarryCommand || (exports.EVoyageCrewCarryCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.CrewCarry;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.command);
    messageWriter_sidecar_1.messageWriter.write8(m, d.type);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.carryId1);
    messageWriter_sidecar_1.messageWriter.write32(m, d.carryId2);
    messageWriter_sidecar_1.messageWriter.write16(m, d.i);
    messageWriter_sidecar_1.messageWriter.write16(m, d.j);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        command: messageWriter_sidecar_1.messageWriter.read8(m),
        type: messageWriter_sidecar_1.messageWriter.read8(m),
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        carryId1: messageWriter_sidecar_1.messageWriter.read32(m),
        carryId2: messageWriter_sidecar_1.messageWriter.read32(m),
        i: messageWriter_sidecar_1.messageWriter.read16(m),
        j: messageWriter_sidecar_1.messageWriter.read16(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 100,
        type: voyageCarryableData_1.EVoyageCarryableType.Coffee,
        command: EVoyageCrewCarryCommand.Create,
        carryId1: 123,
        carryId2: 456,
        i: 7,
        j: 8,
    };
    messageWriter_sidecar_1.messageWriter.test('crew-carry', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.command === EVoyageCrewCarryCommand.Create) {
        // console.log('create item, ', msg.type, msg.carryId1)
        var cy = voyageCarryable_sidecar_1.voyageCarryable.create(msg.type, msg.carryId1);
        if (msg.crewId) {
            var cr = diveCrew_sidecar_1.diveCrew.findByIdSafe(msg.crewId);
            if (!cr) {
                websockets_sidecar_1.websockets.reportBadCommand(m, msg, 'voyageMessage-crew-carry', 'crewId');
                return;
            }
            // if (msg.type === EVoyageCarryableType.CrewCorpse) {
            //   if (cr.crewState && cr.crewState.body) {
            //     voyageBodies.rotate(cr.crewState.body)
            //     voyageCarryable.setBody(cy, cr.crewState.body)
            //     cr.crewState.body = null
            //     // TODO: fix this
            //     // voyageCarryable.setAtTile(cy, cr.tile)
            //     diveCrew.kill(cr)
            //   }
            // } else {
            //   voyageCarryable.setAtCrew(cy, cr)
            // }
        }
        else {
            var t = voyageTilemap_sidecar_1.voyageTilemap.getSafe(msg.i, msg.j);
            assert_sidecar_1.assert.notNil(t);
            voyageCarryable_sidecar_1.voyageCarryable.setAtTile(cy, t);
        }
    }
    if (msg.command === EVoyageCrewCarryCommand.Destroy) {
        var cy = voyageCarryable_sidecar_1.voyageCarryable.findById(msg.carryId1);
        assert_sidecar_1.assert.notNil(cy);
        voyageCarryable_sidecar_1.voyageCarryable.kill(cy);
    }
    if (msg.command === EVoyageCrewCarryCommand.Pickup) {
        var cy = voyageCarryable_sidecar_1.voyageCarryable.findById(msg.carryId1);
        assert_sidecar_1.assert.notNil(cy);
        var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
        assert_sidecar_1.assert.notNil(cr);
        voyageCarryable_sidecar_1.voyageCarryable.setAtCrew(cy, cr);
    }
    if (msg.command === EVoyageCrewCarryCommand.Drop) {
        var cy = voyageCarryable_sidecar_1.voyageCarryable.findById(msg.carryId1);
        assert_sidecar_1.assert.notNil(cy);
        var t = voyageTilemap_sidecar_1.voyageTilemap.getSafe(msg.i, msg.j);
        assert_sidecar_1.assert.notNil(t);
        voyageCarryable_sidecar_1.voyageCarryable.setAtTile(cy, t);
    }
    if (msg.command === EVoyageCrewCarryCommand.Swap) {
        var cy1 = voyageCarryable_sidecar_1.voyageCarryable.findById(msg.carryId1);
        assert_sidecar_1.assert.notNil(cy1);
        var cy2 = voyageCarryable_sidecar_1.voyageCarryable.findById(msg.carryId2);
        assert_sidecar_1.assert.notNil(cy2);
        var t = voyageTilemap_sidecar_1.voyageTilemap.getSafe(msg.i, msg.j);
        assert_sidecar_1.assert.notNil(t);
        var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
        assert_sidecar_1.assert.notNil(cr);
        voyageCarryable_sidecar_1.voyageCarryable.setAtTile(cy1, t);
        voyageCarryable_sidecar_1.voyageCarryable.setAtCrew(cy2, cr);
    }
    //   if (msg.type === EVoyageCarryableType.BattleRifle) {
    //     let t = voyageTilemap.getSafe(msg.i, msg.j)
    //     if (t && t.system && t.system.data) {
    //       t.system.ammo++
    //     }
    //   }
    // }
}
exports.process = process;
function sendCreateMessageAndImmediatelyExecute(params) {
    assert_sidecar_1.assert.t(voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost());
    var id = common_1.createId();
    sendMessageAndImmediatelyExecute({
        type: params.type,
        carryId1: id,
        carryId2: 0,
        command: EVoyageCrewCarryCommand.Create,
        crewId: params.crewId || 0,
        i: params.i,
        j: params.j,
    });
    return id;
}
exports.sendCreateMessageAndImmediatelyExecute = sendCreateMessageAndImmediatelyExecute;
function sendDestroyMessageAndImmediatelyExecute(params) {
    assert_sidecar_1.assert.t(voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost());
    sendMessageAndImmediatelyExecute({
        type: voyageCarryableData_1.EVoyageCarryableType.Null,
        carryId1: params.id,
        carryId2: 0,
        command: EVoyageCrewCarryCommand.Destroy,
        crewId: 0,
        i: 0,
        j: 0,
    });
}
exports.sendDestroyMessageAndImmediatelyExecute = sendDestroyMessageAndImmediatelyExecute;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
function sendMessageWorldState(msg, multiId) {
    websockets_sidecar_1.websockets._sendMessageWorldState(write, msg, multiId);
}
exports.sendMessageWorldState = sendMessageWorldState;
